// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!
/* tslint:disable */
export const APP_VERSION = '1.0.0';
export const APP_NAME = 'tim';
export const FILE_HASH = '1713522838188';
export const BUILD_DATE = '2024-04-19T10:33:58.188Z';
/* tslint:enable */
